import React from "react";
import styled from "styled-components";
import { colors } from "../styles";
import { DeleteOutlined } from '@ant-design/icons';

const VisionCard = ({ card, onClick, onDelete, isOwner }) => {
  const handleDelete = (e) => {
    e.stopPropagation();
    if (card && card.docId) {
      onDelete(card.docId);
    }
  };
  
  return (
    <Card onClick={onClick}>
      {isOwner && (
        <DeleteButton onClick={handleDelete}>
          <DeleteOutlined />
        </DeleteButton>
      )}
      <ImageContainer>
        <Image src={card.imgSrc} alt={card.title} />
      </ImageContainer>
      <Content>
        <Title>{card.title}</Title>
        <Description>{card.description}</Description>
      </Content>
      {isOwner && !card.isPublic && (
        <PrivateIndicator>
          🔒 Privado
        </PrivateIndicator>
      )}
    </Card>
  );
};



const ImageContainer = styled.div`
  margin-bottom: 15px;
  background-color: ${colors.white};
  padding: 8px;
`;

const Image = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const Content = styled.div`
  padding: 0 8px;
`;

const Title = styled.h3`
  font-family: 'Caveat', cursive;
  font-size: 1.5rem;
  color: ${colors.text};
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  color: ${colors.text};
  line-height: 1.4;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: ${colors.white};
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px ${colors.shadow};
  color: ${colors.text};

  &:hover {
    background: ${colors.secondary};
    color: ${colors.white};
    transform: scale(1.1);
  }
`;

const Card = styled.div`
  background-color: ${colors.white};
  border-radius: 3px;
  padding: 12px 12px 20px 12px;
  box-shadow: 0 4px 8px ${colors.shadow};
  transform: rotate(-1deg);
  transition: transform 0.3s ease;
  cursor: pointer;
  position: relative;
  
  &:hover {
    transform: rotate(0deg) scale(1.02);
  }

  &:hover ${DeleteButton} {
    opacity: 1;
  }
`;

const PrivateIndicator = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
`;

export { VisionCard };
